<form [formGroup]="validateProviderForm">
  <div>
    <div class="flex flex-col mb-4">
      <label class="font-bold mb-2" for="npi">NPI</label>
      <input
        id="npi"
        type="text"
        pInputText
        formControlName="npi"
      >
    </div>

    <div class="flex flex-col mb-4">
      <label class="font-bold mb-2" for="tax-id">Enter TAX ID</label>
      <input
        id="tax-id"
        type="text"
        pInputText
        formControlName="taxId"
      >
      @if (validateProviderForm.invalid && (validateProviderForm.touched || validateProviderForm.dirty)) {
        @if (validateProviderForm.controls.taxId.errors.taxIdMatch) {
          <div class="p-error">
            Tax ID does not match. Please try again or Cancel.
          </div>
        }
        @if (validateProviderForm.controls.taxId.errors.required) {
          <div class="p-error">
            Tax ID is required.
          </div>
        }
      }
    </div>
  </div>
  <p-message severity="info" styleClass="my-4">
    Please include all zero’s at the beginning and/or end of the Tax ID number
  </p-message>
</form>
<div class="flex justify-between">
  <button
    pButton
    type="button"
    icon="pi pi-times"
    label="Cancel"
    class="p-button-secondary"
    (click)="close()"
  ></button>
  <button
    pButton
    class="validate-submit"
    type="button"
    [label]="isLoading ? '' : 'Validate and Add'"
    [icon]="isLoading ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
    [disabled]="!validateProviderForm.valid || isLoading"
    (click)="add()"
  ></button>
</div>
